import { request, requestWithParams } from "utils/fetchData";
import { API_BASE_URL } from "config/constants";

export const setUserSettingApiRequest = (params) =>
    request(
        `${API_BASE_URL}/userSettings/set-new-setting-value`,
        "POST",
        params
    );

export const getTimeZones = () =>
    request(`${API_BASE_URL}/userSettings/getTimeZones`, "GET", null);
